import React, { useContext } from 'react';
import { Grid, AppBar, Tab, Tabs, MenuItem, TextField } from '@mui/material';
import { ticketDetailsContext } from './TicketDetailsContext';
import { applicationContext, appUserContext } from 'helpers/services';
import { BaseInfo, Documents, Messages, People, Orders, Team, TicketDetailsPageHeader } from './components';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { Page } from 'components';
import Activities from './components/Activities';


let TicketDetails = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);
    let { ticketSubCategories } = useContext(applicationContext);
    let service = useContext(ticketDetailsContext);


    let [tab, setTab] = React.useState<string>(LocalizationIds.Messages);


    return (
        <div>
            {service.isLoading === false &&
                <Page title={`${service.ticket.ticketNumber} ${service.ticket.customerName}`}>
                    <TicketDetailsPageHeader
                        pageTitle={service.ticket.title}
                        subTitle={`${service.ticket.ticketNumber}`}
                        customerName={service.ticket.customerName}
                        customerLink={`${process.env.REACT_APP_CRM_URL}/contact/${service.ticket.customerId}`}
                    />
                    <Grid container>
                        <Grid item xs={12} md={4}>
                            <BaseInfo />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            {isMobile === false &&
                                <AppBar position="static" color="secondary">
                                    <Tabs
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        value={tab}
                                        variant="scrollable"
                                        onChange={(e, newValue) => setTab(newValue)}
                                    >
                                        <Tab label={formatMessage({ id: LocalizationIds.Messages })} value={LocalizationIds.Messages} />
                                        <Tab label={formatMessage({ id: LocalizationIds.LinkedOrders })} value={LocalizationIds.LinkedOrders} />
                                        <Tab label={formatMessage({ id: LocalizationIds.Documents })} value={LocalizationIds.Documents} />
                                        {(ticketSubCategories.getValueByKey(service.ticket.ticketSubCategoryId, 'id', 'categoryFromCustomer') || false) === true &&
                                            <Tab label={formatMessage({ id: LocalizationIds.Team })} value={LocalizationIds.Team} />
                                        }
                                        <Tab label={formatMessage({ id: LocalizationIds.People })} value={LocalizationIds.People} />
                                        <Tab label={formatMessage({ id: LocalizationIds.Activities })} value={LocalizationIds.Activities} />
                                    </Tabs>
                                </AppBar>
                            }
                            {isMobile === true &&
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TextField
                                            select
                                            name="tab"
                                            value={tab}
                                            onChange={(e: any) => {
                                                setTab(e.target.value);
                                            }}
                                            variant="standard"
                                        >
                                            <MenuItem value={LocalizationIds.Messages}>
                                                {formatMessage({ id: LocalizationIds.Messages })}
                                            </MenuItem>
                                            <MenuItem value={LocalizationIds.LinkedOrders}>
                                                {formatMessage({ id: LocalizationIds.LinkedOrders })}
                                            </MenuItem>
                                            <MenuItem value={LocalizationIds.Documents}>
                                                {formatMessage({ id: LocalizationIds.Documents })}
                                            </MenuItem>
                                            {(ticketSubCategories.getValueByKey(service.ticket.ticketSubCategoryId, 'id', 'categoryFromCustomer') || false) === true &&
                                                <MenuItem value={LocalizationIds.Team}>
                                                    {formatMessage({ id: LocalizationIds.Team })}
                                                </MenuItem>
                                            }
                                            <MenuItem value={LocalizationIds.People}>
                                                {formatMessage({ id: LocalizationIds.People })}
                                            </MenuItem>
                                            <MenuItem value={LocalizationIds.Activities}>
                                                {formatMessage({ id: LocalizationIds.Activities })}
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            }

                            <div role="tabpanel" hidden={tab !== LocalizationIds.Documents}>
                                <Documents />
                            </div>
                            <div role="tabpanel" hidden={tab !== LocalizationIds.LinkedOrders}>
                                <Orders />
                            </div>
                            <div role="tabpanel" hidden={tab !== LocalizationIds.Messages}>
                                <Messages />
                            </div>
                            <div role="tabpanel" hidden={tab !== LocalizationIds.People}>
                                <People />
                            </div>
                            {(ticketSubCategories.getValueByKey(service.ticket.ticketSubCategoryId, 'id', 'categoryFromCustomer') || false) === true &&
                                <div role="tabpanel" hidden={tab !== LocalizationIds.Team}>
                                    <Team />
                                </div>
                            }
                            <div role="tabpanel" hidden={tab !== LocalizationIds.Activities}>
                                <Activities />
                            </div>
                        </Grid>
                    </Grid>
                </Page>
            }
        </div>
    )
}

export default TicketDetails;